export const AUTH_LOADING = "auth/loading"
export const AUTH_LOGIN = "auth/login";
export const AUTH_LOGOUT = "auth/logout";
export const AUTH_ERROR = "auth/error";
export const SAVEDATA = "save/data"
